import React from 'react';
import { AnnouncementTypesLookup } from '../AnnouncementTypesLookup/AnnouncementTypesLookup';
import AnnouncementTypeEnum from 'common/constants/AnnouncementTypeEnum';
import styles from './AnnouncementTypeIconLookup.module.scss';
const AnnouncementTypeIconLookup = ({ type = AnnouncementTypeEnum.WEBINAR }) => {
    const iconType = type.toLowerCase();
    const { Icon, announcementId } = AnnouncementTypesLookup[iconType];
    const styleIconType = `icon_${announcementId}`;
    return (<div className={`${styles.badge} ${styles[announcementId]}`}>
            <Icon aria-label={announcementId} className={styles[styleIconType]} color="white"/>
        </div>);
};
export default AnnouncementTypeIconLookup;
